import {BetLine} from "@nolimitcity/slot-game/bin/core/betline/BetLine";
import {BetLinesView, IBetLinesViewConfig} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../CreepyCarnivalTwoSoundConfig";
import {CCTwoTextBetLineNumber} from "./number/CCTwoTextBetLineNumber";

export class CreepyCarnivalBetLineEvent extends BetLineEvent {
    static readonly SHOW_ALL_BET_LINES:string = "CCT_SHOWALL_BETLINES";
    static readonly SHOW_ALL_MAIN_BET_LINES:string = "CCT_SHOWALL_MAIN_BETLINES";
    static readonly SHOW_FREE_SPIN_ALL_BET_LINES:string = "CCT_SHOWALL_FREESPIN_BETLINES";
    static readonly HIDE_FREE_SPIN_ALL_BET_LINES:string = "CCT_HIDEALL_FREESPIN_BETLINES";
}

export class CCTwoBetlinesView extends BetLinesView {

    private readonly _numberFactoryMethodCCTwo:(index:number) => CCTwoTextBetLineNumber;
    private readonly _lineFactoryMethodCCTwo:(index:number, numberPosition:number[], betLineData:number[]) => BetLine;

    private readonly _configCCTwo:IBetLinesViewConfig;
    private _betLinesDataCCTwo:number[][];
    private _red_container:PIXI.Container = new PIXI.Container();


    constructor(config:IBetLinesViewConfig,
                numberFactoryMethod:(index:number) => CCTwoTextBetLineNumber,
                lineFactoryMethod:(index:number, numberPosition:number[], betLineData:number[]) => BetLine) {

        super(config, numberFactoryMethod, lineFactoryMethod);

        this._numberFactoryMethodCCTwo = numberFactoryMethod;
        this._lineFactoryMethodCCTwo = lineFactoryMethod;
        this._configCCTwo = config;
    }

    public getBetNumberByIndex(index:number):void | any {
        for(let i = 0; i < this._betLineNumbers.length; i++) {
            if(this._betLineNumbers[i].index !== index) {

            } else {
                return this._betLineNumbers[i];
            }

        }
    }

    public showAllBetlines(betLineWinData:IBetLineWinData[]) {
        for(let i:number = 0; i < betLineWinData.length; ++i) {
            this._betLines[betLineWinData[i].betLineIndex].alpha = 1;
            this._betLineNumbers[betLineWinData[i].betLineIndex].getChildAt(1).alpha = 0;
            this._betLineNumbers[betLineWinData[i].betLineIndex].getChildAt(2).alpha = 1;
        }
    }

    public showAllFreeBetlinesAndIndicators(betLineWinData:[]) {
        this._red_container = <PIXI.Container>StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.BULBS.name).getChildByName("red_container");
        for(let i:number = 0; i < CreepyCarnivalTwoGameConfig.instance.BETLINES.length; i += 1) {
            for(let j:number = 0; j < betLineWinData.length; j += 1) {
                if(this._betLines[i].index == betLineWinData[j]) {
                    this._betLines[i].alpha = 1;
                    this._betLineNumbers[i].alpha = 1;
                }
            }
        }
    }

    public showAnimationFreeBetlinesAndIndicators(data:any) {
        this._red_container = <PIXI.Container>StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.BULBS.name).getChildByName("red_container");
        const betLineWinData = data.x;
        const mainTimeline = data.y;
        let count = 0;
        let timeLineBetlines:TimelineLite = new TimelineLite({
            onComplete : () => {
                for(let i:number = 0; i < this._red_container.children.length; i++) {
                    this.turnOffBulb(i, mainTimeline);
                }

            }
        });
        //for left side betlines
        for(let j:number = betLineWinData.length / 2 - 1; j >= 0; j -= 1) {
            for(let i:number = 0; i < CreepyCarnivalTwoGameConfig.instance.BETLINES.length; i += 1) {
                if(this._betLines[i].index == betLineWinData[j]) {
                    this.showBetLine(i, count, j, timeLineBetlines);
                }
            }
            count++;
            if(count == 10) {
                for(let j:number = betLineWinData.length / 2; j < betLineWinData.length; j += 1) {
                    for(let i:number = 0; i < CreepyCarnivalTwoGameConfig.instance.BETLINES.length; i += 1) {

                        if(this._betLines[i].index == betLineWinData[j]) {
                            this.showBetLine(i, count, j, timeLineBetlines);
                        }
                    }
                    count++;
                }
            }
        }
    }


    public hideAllFreeBetlinesAndIndicators(betLineWinData:[]) {
        this._red_container = <PIXI.Container>StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.BULBS.name).getChildByName("red_container");
        for(let i:number = 0; i < CreepyCarnivalTwoGameConfig.instance.BETLINES.length; i += 1) {
            for(let j:number = 0; j < betLineWinData.length; j += 1) {
                if(this._betLines[i].index == betLineWinData[j]) {
                    this._betLines[i].alpha = 0;
                    let removeTimeLineBetlines:TimelineLite = new TimelineLite({paused : true});
                    removeTimeLineBetlines.add(() => {
                        TweenLite.fromTo(this._betLineNumbers[i].scale, 0.2, {x : 1}, {x : 0});
                    });
                    removeTimeLineBetlines.play(0);
                }
            }
        }
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            if(this._betLineNumbers.length > 0) {
                const map:number[] = this._configCCTwo.map;
                for(let i:number = 0; i < map.length / 2; i += 2) {
                    let betlineNum = this.getBetNumberByIndex(map[i]); //left free spinnums
                    betlineNum && betlineNum.getChildAt(0).scale.set(0.75, .70);

                    betlineNum.children[1].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNum.children[2].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNum && betlineNum.getChildAt(0).position.set(19, 20);
                    betlineNum && betlineNum.getChildAt(1).position.set(19, 20);
                    betlineNum && betlineNum.getChildAt(2).position.set(19, 20);
                    let betlineNumMain = this.getBetNumberByIndex(map[i + 1]); //left main spinnums
                    betlineNumMain && betlineNumMain.getChildAt(0).scale.set(0.85, .65);

                    betlineNumMain.children[1].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNumMain.children[2].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNumMain && betlineNumMain.getChildAt(0).position.set(2, 23);
                    betlineNumMain && betlineNumMain.getChildAt(1).position.set(4, 23);
                    betlineNumMain && betlineNumMain.getChildAt(2).position.set(4, 23);
                }

                for(let i:number = map.length / 2; i < map.length; i += 2) {
                    let betlineNum = this.getBetNumberByIndex(map[i]); //right free spinnums
                    betlineNum && betlineNum.getChildAt(0).scale.set(-0.75, .70);

                    // betlineNum.children[0].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNum.children[1].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNum.children[2].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNum && betlineNum.getChildAt(0).position.set(-12, 20);
                    betlineNum && betlineNum.getChildAt(1).position.set(-12, 20);
                    betlineNum && betlineNum.getChildAt(2).position.set(-12, 20);
                    let betlineNumMain = this.getBetNumberByIndex(map[i + 1]); //right main spinnums
                    betlineNumMain && betlineNumMain.getChildAt(0).scale.set(-0.85, .65);

                    //betlineNumMain.children[0].setTransform(0, 0, -1, 1, 0, 0);
                    betlineNumMain.children[1].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNumMain.children[2].setTransform(0, 0, 1, 1, 0, 0);
                    betlineNumMain && betlineNumMain.getChildAt(0).position.set(-7, 23);
                    betlineNumMain && betlineNumMain.getChildAt(1).position.set(-7, 22);
                    betlineNumMain && betlineNumMain.getChildAt(2).position.set(-7, 22);
                }
            }
        }

    }

    private onInitDataParsedCCTwo(data:ParsedInitData):void {
        this._betLinesDataCCTwo = data.betLines;
        if(this._betLinesDataCCTwo.length != this._configCCTwo.map.length) {
            debugger;
            throw new Error(`Error: There are only ${this._configCCTwo.map.length} betLines in the config order while the server sends ${this._betLinesDataCCTwo.length} lines.`);
        }

        this._dataInitialized = true;
        this.draw();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsedCCTwo(event.params[0]));
        EventHandler.addEventListener(this, CreepyCarnivalBetLineEvent.SHOW_ALL_MAIN_BET_LINES, (event:GameEvent) => this.showAllBetlines(event.params[0]));
        EventHandler.addEventListener(this, CreepyCarnivalBetLineEvent.SHOW_ALL_BET_LINES, (event:GameEvent) => this.showAllFreeBetlinesAndIndicators(event.params[0]));
        EventHandler.addEventListener(this, CreepyCarnivalBetLineEvent.HIDE_FREE_SPIN_ALL_BET_LINES, (event:GameEvent) => this.hideAllFreeBetlinesAndIndicators(event.params[0]));
        EventHandler.addEventListener(this, CreepyCarnivalBetLineEvent.SHOW_FREE_SPIN_ALL_BET_LINES, (event:GameEvent) => this.showAnimationFreeBetlinesAndIndicators(event.params[0]));
    }

    private showBetLine(index:number, loopIndex:number, bulbIndex:number, timeLineBetlines:TimelineLite) {
        timeLineBetlines.add(() => {
            TweenLite.fromTo(this._red_container.getChildAt(bulbIndex), 0.05, {alpha : 0}, {alpha : 1});
            TweenLite.fromTo(this._betLines[index], 0.05, {alpha : 0}, {alpha : 1});
            TweenLite.fromTo(this._betLineNumbers[index].scale, 0.05, {x : 0}, {x : 1});
            this._betLineNumbers[index].alpha = 1;
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.LIGHTS_ON);
        }, loopIndex * 0.25);
        if(loopIndex == 19) {
            timeLineBetlines.play(0);
        }

    }

    private turnOffBulb(indd:number, mainTimeLine:TimelineLite) {
        mainTimeLine.add(() => {
            this._red_container.getChildAt(indd).alpha = 0;
        }, indd * 0.05);
        if(indd == 19) {
            mainTimeLine.play(0);
        }
    }

    protected draw():void {
        if(!this._resourcesLoaded || !this._dataInitialized) {
            return;
        }

        const map:number[] = this._configCCTwo.map;
        for(let i:number = 0; i < map.length; i += 2) {
            //freeSpins
            const betLineNumber:CCTwoTextBetLineNumber = this._numberFactoryMethodCCTwo(map[i]);
            const betLineNumberPosition:number[] = betLineNumber.setPosition(this._betLinesDataCCTwo.length, i);
            this._betLineNumbers.push(betLineNumber);
            betLineNumber.alpha = 0;
            const betLine:BetLine = this._lineFactoryMethodCCTwo(map[i], betLineNumberPosition, this._betLinesDataCCTwo[map[i] - 1]);
            this._betLines.push(betLine);
        }
        for(let i:number = 1; i < map.length; i += 2) {
            const betLineNumber:CCTwoTextBetLineNumber = this._numberFactoryMethodCCTwo(map[i]);
            const betLineNumberPosition:number[] = betLineNumber.setPosition(this._betLinesDataCCTwo.length, i);
            this._betLineNumbers.push(betLineNumber);

            const betLine:BetLine = this._lineFactoryMethodCCTwo(map[i], betLineNumberPosition, this._betLinesDataCCTwo[map[i] - 1]);
            this._betLines.push(betLine);
        }

        for(let i:number = 0; i < this._betLineNumbers.length; i += 2) {
            this._betLineNumbers[i].children[1].rotation = -0.2;
            this._betLineNumbers[i].children[2].rotation = -0.2;
        }
        for(let i:number = 1; i < this._betLineNumbers.length; i += 2) {
            this._betLineNumbers[i].children[1].rotation = 0.2;
            this._betLineNumbers[i].children[2].rotation = 0.2;
        }
        for(let j:number = 0; j < this._betLineNumbers.length; j++) {
            if(this._betLineNumbers[j].position.x > 500) {
                this._betLineNumbers[j].children[0].setTransform(0, 0, -1, 1, 0, 0);
                // this._betLineNumbers[j].children[0].scale.set(0.6);
            }
        }
        this._betLines.sort((a:BetLine, b:BetLine) => {
            return a.index - b.index;
        });

        (<CCTwoTextBetLineNumber[]>this._betLineNumbers).sort((a:CCTwoTextBetLineNumber, b:CCTwoTextBetLineNumber) => {
            return a.index - b.index;
        });
    }
}